import ContentCard from "@/pages/home/components/ContentCard";

interface SearchItem {
  id: string;
  category: string;
  tag: string;
  title: string;
  excerpt: string;
  cover: string;
  readCount: string;
  date: string;
  hot?: number;
}

interface SearchResultsProps {
  query: string;
  items: SearchItem[];
  onClear: () => void;
  onCategorySelect: (category: string) => void;
}

export default function SearchResults({ query, items, onClear, onCategorySelect }: SearchResultsProps) {
  return (
    <section id="search-results" className="w-full bg-background-50 pt-10 md:pt-14 pb-2">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <div className="rounded-card border border-primary-200 bg-primary-50/60 p-5 md:p-6">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <div>
              <p className="text-xs md:text-sm text-foreground-600">搜索结果</p>
              <h2 className="mt-1 font-heading text-xl md:text-2xl font-bold text-foreground-950">
                “{query}” 共命中 <span className="text-primary-600">{items.length}</span> 条内容
              </h2>
            </div>
            <button
              type="button"
              onClick={onClear}
              className="inline-flex items-center gap-1.5 rounded-md border border-primary-300 bg-background-50 px-4 py-2 text-sm font-medium text-primary-700 whitespace-nowrap cursor-pointer transition-colors hover:bg-primary-100"
            >
              <i className="ri-close-line"></i>
              清除搜索
            </button>
          </div>
        </div>

        {items.length > 0 ? (
          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {items.map((item) => (
              <ContentCard key={item.id} item={item} onCategorySelect={onCategorySelect} />
            ))}
          </div>
        ) : (
          <div className="mt-6 rounded-card border border-dashed border-background-300 bg-background-100 py-16 text-center">
            <i className="ri-search-eye-line text-4xl text-foreground-400"></i>
            <p className="mt-3 text-sm md:text-base text-foreground-700">没有找到匹配的内容</p>
            <p className="mt-1.5 text-xs md:text-sm text-foreground-500">
              试试更短的关键词，或换个说法再搜索一次。
            </p>
            <button
              type="button"
              onClick={onClear}
              className="mt-5 inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 whitespace-nowrap cursor-pointer transition-colors hover:bg-primary-600"
            >
              <i className="ri-refresh-line"></i>
              返回全部内容
            </button>
          </div>
        )}
      </div>
    </section>
  );
}